export default function CourseContact() {
    return (
        <div className="details-requirement">
            <div className="requirement-content">
                <div className="subtitle">E-mail:</div>
                <div className="description">
                    <a href="mailto:educacion@medicinafetalmexico.com">educacion@medicinafetalmexico.com</a>
                </div>
            </div>
            <div className="requirement-content">
                <div className="subtitle">WhatsApp</div>
                <div className="description">
                    <a href="https://api.whatsapp.com/send/?phone=523310824629">(+52)3310824629</a>
                </div>
            </div>
        </div>
    )
}
